import React, { Component } from 'react';
import { changeColorTint } from '../../../styles/utils';
import moment from 'moment';
import haversineInYards from '../../../utils/haversine';

import { alertTypes } from '../../../store/reducers/alerts';
import { convertToLocalTime } from '../../../utils/timeUtils';
import ImageThumbnail from '../../imgs/thumbnail';

const AlertItem = ({ alerts: alerts, ...props }) => {
  return alerts.map((alert) => {
    let type = alertTypes[alert.alert_type].name;
    let value;
    if (type === 'Response Inactivity') {
      value = `${Math.ceil(alert.value)} min`;
    } else {
      let yards = alert.value * 1.094;

      try {
        yards = yards.toFixed(2);
      } catch {
        yards = Math.ceil(yards);
      }
      // default display value is yards, comes in as meters.
      value = `${yards} yds`;
    }
    return (
      <div className="obj-title" style={{ color: 'red' }}>
        <i
          className="fas fa-exclamation-triangle"
          style={{ color: 'orange', padding: '0em .5em' }}
        />{' '}
        {type}: {value}
      </div>
    );
  });
};

class CanvasserActionListItem extends Component {
  constructor(props) {
    super(props);

    this.distance = this._getDistanceFromLocation();
    this.timeDiff = this._getDifferenceBetweenPhoneAndSendTime();

    this.geoLocationAlertSensitivity = props.data.event_type === 'door_canvass' ? 60 : 180;
  }

  _generateSubData = () => {
    let site_name = this.props.data.site ? this.props.data.site.name : '';
    switch (this.props.data.event_type) {
      case 'check_in':
      case 'check_out':
        return <div className="obj-data">{site_name}</div>;

      case 'log_response':
        if (!this.props.data.response || !this.props.data.response.length) {
          return <div className="obj-data">Responses were not found.</div>;
        } else {
          let res = [];
          if (this.props.data.door)
            res.push(
              <div className="obj-data" style={{ fontWeight: 'Bold' }}>
                {(this.props.data.door || {}).street_address_1}{' '}
                {(this.props.data.door || {}).street_address_2}
              </div>
            );
          this.props.data.response
            .sort((a, b) => (a.media_src ? -1 : a.id > b.id ? 1 : -1))
            .forEach((d) => {
              res.push(
                <>
                  <div className="obj-data">
                    {d.media_src ? (
                      <ImageThumbnail src={d.media_thumb_src} largeSrc={d.media_src} />
                    ) : (
                      <div>{d.response}</div>
                    )}
                  </div>
                </>
              );
            });
          return res;
        }

      case 'door_canvass':
        const primary = this.props.data?.door?.primary_phone;
        const secondary = this.props.data?.door?.secondary_phone;
        const primaryText = primary ? `Phone 1: ${primary}` : '';
        const secondaryText = secondary ? `Phone 2: ${secondary}` : '';

        return (
          <>
            <div className="obj-data" style={{ fontWeight: 'Bold' }}>
              {(this.props.data.door || {}).street_address_1}{' '}
              {(this.props.data.door || {}).street_address_2}
            </div>
            <div className="obj-data">{(this.props.data.status || '').replace('_', ' ')}</div>
            {primary && <div className="obj-data">{primaryText} </div>}
            {secondary && <div className="obj-data">{secondaryText} </div>}
          </>
        );

      case 'training_start':
      case 'training_end':
        return (
          <>
            <div className="obj-data" style={{ fontWeight: 'Bold' }}>
              {!!this.props.data?.ex_info?.trainee_name && 'Trainee:'}{' '}
              {this.props.data?.ex_info?.trainee_name}
            </div>
          </>
        );

      case 'log_in':
      case 'log_out':
      default:
        return <div />;
    }
  };

  _getDistanceFromLocation = () => {
    let { data } = this.props;
    let { latitude: elat, longitude: elon } = data;

    let tlat, tlon;
    if (data.door) {
      tlat = +data.door.lat;
      tlon = +data.door.lon;
    } else if (data.site) {
      tlat = +data.site.lat;
      tlon = +data.site.lon;
    }

    if (!(elat && elon && tlat && tlon)) return 0;

    let distance = haversineInYards(+elat, +elon, +tlat, +tlon);
    return Math.floor(distance);
  };

  _getDifferenceBetweenPhoneAndSendTime = () => {
    let { event_time, phone_time } = this.props.data;

    let diff = moment.duration(moment(event_time).diff(moment(phone_time)));
    let milliseconds = diff._milliseconds || 0;
    if (milliseconds / (60 * 60 * 1000) > 1) {
      console.log('diff is true', milliseconds / (60 * 60 * 1000));
      return diff;
    } else {
      return false;
    }
  };

  _buildTimeDiffWarning = () => {
    if (!this.timeDiff) return <></>;

    return (
      <div className={'obj-data'} style={{ color: 'red' }}>
        <i className="far fa-clock" /> Packet is{' '}
        {this.timeDiff.days() ? `${this.timeDiff.days()} days, ` : ''}
        {this.timeDiff.hours() ? `${this.timeDiff.hours()} hrs, ` : ''}
        {this.timeDiff.minutes() ? `${this.timeDiff.minutes()} min ` : ''}
        late
      </div>
    );
  };

  render() {
    let { data, focused } = this.props;

    return (
      <div
        className={`side-menu-list-obj ${focused && 'focused'}`}
        onMouseEnter={this.props.onMouseEnter}
        onMouseLeave={this.props.onMouseLeave}
        onClick={this.props.onTitleClick}
      >
        {/*inner wrapper to generate side color border*/}
        <div className="list-obj-inner-wrapper" style={{ borderLeftColor: data.color }}>
          <div className="obj-title" onClick={this.props.onTitleClick}>
            {typeof data.event_type === 'string'
              ? data.event_type.replace('_', ' ')
              : data.event_type}
          </div>
          {this._generateSubData()}
          <div className="obj-data">{moment(data.phone_time).format('hh:mm')}</div>
        </div>

        {this._buildTimeDiffWarning()}

        {this.distance > this.geoLocationAlertSensitivity && (
          <div className={'obj-data'} style={{ color: 'red' }}>
            <i className="fas fa-exclamation-triangle"></i> {this.distance} Yards from Target{' '}
            {data.loc_accuracy ? `(±${Math.round(data.loc_accuracy * 1.093613)})` : ''}
          </div>
        )}

        {(!data.longitude || !data.latitude || data.bad_loc_on_last_update) && (
          <div className={'obj-data'} style={{ color: 'red' }}>
            <i className="fas fa-exclamation-triangle"></i> Bad Location Update
          </div>
        )}
      </div>
    );
  }
}

export default CanvasserActionListItem;
